import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { ApiRouteLabelService } from '../../../api/elite/routes/label.service';

export abstract class SchedulerItemApiAbstract {
  protected readonly apiLabelRouter = inject(ApiRouteLabelService);

  abstract updateRank(itemId: number, rank: string): Observable<any>;

  // abstract changePriority(itemId: number, priority: boolean): Observable<any>;

  // abstract deleteWorkOrder(itemId: number): Observable<any>;

  // abstract startWorkOrder(itemId: number, machineId: number): Observable<any>;

  printBasicItem(
    workOrderId: number,
    quantity: number,
    quantityOfLabels = 1,
    namePrinter?: string,
    batch?: string
  ): Observable<any> {
    return this.apiLabelRouter.printLabel({
      workOrderId,
      quantity,
      quantityOfLabels,
      namePrinter,
      batch,
    });
  }
}
